import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { state, style, trigger } from '@angular/animations';
import { ApiUrls } from '../../const/Api-urls';
@Component({
  selector: 'app-util-file-viewer',
  templateUrl: './util-file-viewer.component.html',
  styleUrls: ['./util-file-viewer.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-90deg)' })),
      state('other', style({ transform: 'rotate(-180deg)' })),
      state('other1', style({ transform: 'rotate(-270deg)' })),
    ])
  ]
})
export class UtilFileViewerComponent implements OnInit {

  // fileDownload = ApiUrls.fileDownload;
  // downloadPdf = ApiUrls.downloadPdf;

  @Input() receivedFileFromParent: any;
  @Output() newItemEvent = new EventEmitter<any>();

  isImg: string | null = null;
  isPdf: string | null = null;
  unsuppFile: string | null = null;
  selectedFile: any = null;
  state: string = 'default';

  constructor() { }

  ngOnInit(): void {
    // console.log("File Viewer initialized with: ", this.receivedFileFromParent);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['receivedFileFromParent'] && this.receivedFileFromParent) {
      this.showFile(this.receivedFileFromParent);
    }
  }

  showFile(showFile: any): void {
    this.isImg = null;
    this.isPdf = null;
    this.unsuppFile = null;
    this.selectedFile = null;

    const fileParts = showFile.fileName.split('.');
    const fileType = fileParts[fileParts.length - 1].toLowerCase();
    // console.log(fileType)
    if (['jpg', 'jpeg', 'png'].includes(fileType)) {
      this.isImg = this.getFilePath(showFile.fileUUID);
      this.selectedFile = showFile;

    } else if (fileType === 'pdf') {
      this.isPdf = this.getFilePath(showFile.fileUUID);
      this.selectedFile = showFile;console.log(this.isPdf, this.selectedFile)

    } else {
      this.unsuppFile = 'File type is not supported. Download the file from the link.';
    }
  }

  getFilePath(fileUUID: string): string {
    return ApiUrls.downloadFileUrl1 + fileUUID;
  }

  close() {
    this.isImg = null;
    this.isPdf = null;
    this.unsuppFile = null;
    this.newItemEvent.emit(null);
  }

  rotate(): void {
    this.state = this.state === 'default' ? 'rotated' :
                  this.state === 'rotated' ? 'other' :
                  this.state === 'other' ? 'other1' : 'default';
  }

  downloadFile(): void {
    const fileUrl: string | null = this.isImg || this.isPdf;
    const fileName = this.selectedFile?.fileName || 'file';

    if (!fileUrl) {
      console.error('No file URL available');
      return;
    }

    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(error => console.error('Download failed', error));
  }
}